import type { ASTNode } from "@ronradtke/react-native-markdown-display";
import {
  MarkdownIt,
  stringToTokens,
  tokensToAST,
} from "@ronradtke/react-native-markdown-display";
import isEmpty from "lodash/isEmpty";

const toSentenceCase = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const pluralize = ({
  isLastLetterS,
  itemCount,
}: {
  isLastLetterS?: boolean;
  itemCount: number;
}) => {
  const suffix = isLastLetterS ? "es" : "s";
  return itemCount === 1 ? "" : suffix;
};

const joinWithCommas = (items: string[]): string => {
  return items.join(", ");
};

const joinTestIDs = (...items: string[]): string => {
  return items.join("__");
};

const listWithParentheses = (items: string[]): string => {
  if (isEmpty(items)) return "";
  const listWithCommas = joinWithCommas(items);
  return `(${listWithCommas})`;
};

const extractLinksFromAST = (node: ASTNode): string[] => {
  let links: string[] = [];
  if (node.type === "link" && node.attributes.href) {
    links.push(node.attributes.href);
  }
  if (!isEmpty(node.children)) {
    node.children.forEach((child) => {
      links = links.concat(extractLinksFromAST(child));
    });
  }
  return links;
};

const extractLinksFromMarkdown = (markdown: string): string[] => {
  const markdownIt = new MarkdownIt();

  // Parse the markdown into tokens and then tokens into AST, which is a tree of nodes
  const tokens = stringToTokens(markdown, markdownIt);
  const ast = tokensToAST(tokens);

  const links = ast.flatMap(extractLinksFromAST);
  return links;
};

const getEnglishVersionLink = (links: string[]) => {
  return links.find((link) => link.includes("en"));
};

const toTestID = (input: string): string => {
  return input.trim().toLowerCase().replaceAll(/\s+/g, "-");
};

export {
  extractLinksFromMarkdown,
  getEnglishVersionLink,
  joinTestIDs,
  joinWithCommas,
  listWithParentheses,
  pluralize,
  toSentenceCase,
  toTestID,
};
